import EsusView from 'components/esus/EsusView'
import { useLocation } from 'react-router'

export default function FichaCadastroIndividualDetailView() {
  const { search } = useLocation()

  return <EsusView url={`/pec/user/cds/cadastroIndividual/detail${search}`} />
}
